import { render } from "./IslemYapiliyor.vue?vue&type=template&id=4833b814"
import script from "./IslemYapiliyor.vue?vue&type=script&lang=js"
export * from "./IslemYapiliyor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__